import type { WebPubSubClient } from "@azure/web-pubsub-client";
import { createContext, type ReactNode, useContext, useState } from "react";

interface WebPubSubContextType {
  client: WebPubSubClient | null;
  setClient: (client: WebPubSubClient | null) => void;
}

const WebPubSubContext = createContext<WebPubSubContextType | undefined>(undefined);

export const useWebPubSub = (): WebPubSubContextType => {
  const context = useContext(WebPubSubContext);
  if (!context) {
    console.error("useWebPubSub must be used within a WebPubSubProvider");
    throw new Error("useWebPubSub must be used within a WebPubSubProvider");
  }
  return context;
};

interface WebPubSubProviderProps {
  children: ReactNode;
}

export const WebPubSubProvider = ({ children }: WebPubSubProviderProps) => {
  const [client, setClient] = useState<WebPubSubClient | null>(null);

  return (
    <WebPubSubContext.Provider value={{ client, setClient }}>{children}</WebPubSubContext.Provider>
  );
};
